import { useTableSettings, useToast } from "@/ds";
import { PLANEJAMENTO_CONTROLE_TABLE_DENSITY_KEY } from "@/core/constants/keys";
import { useTableSettingsAppliedToast } from "@/shared/hooks";
import { COLUNAS_CONFIGURACAO } from "./planejamento-controle.constants";

export function useConfiguracaoTabelaPlanejamento() {
  const settings = useTableSettings({
    densityKey: PLANEJAMENTO_CONTROLE_TABLE_DENSITY_KEY,
    allColumns: COLUNAS_CONFIGURACAO,
    mainColumns: COLUNAS_CONFIGURACAO,
  });
  const notificarAplicada = useTableSettingsAppliedToast(useToast());

  return {
    compacta: settings.density === "small",
    dialog: settings.dialog,
    notificarAplicada,
  };
}
